import { api } from '../api.js';
import { store } from '../store.js';
import { navigate } from '../router.js';
import { toast } from '../utils/toast.js';

export async function renderVerifyEmailPage({ root }) {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  root.innerHTML = `<div class="auth-wrapper"><div class="auth-card"><p class="text-center text-muted">Проверяем…</p></div></div>`;

  if (token) {
    try {
      await api.auth.verifyConfirm(token);
      renderSuccess(root);
      try {
        const { user } = await api.auth.me();
        store.user = user;
      } catch {}
    } catch (err) {
      renderFailed(root, err);
    }
    return;
  }

  renderPendingInbox(root);
}

function renderSuccess(root) {
  root.innerHTML = `
    <div class="auth-wrapper">
      <div class="auth-card text-center">
        <h1>Email подтверждён ✓</h1>
        <p class="text-muted">Теперь всё, что связано с аккаунтом, будет работать как надо.</p>
        <div class="actions"><a class="btn" href="/" data-link>На главную</a></div>
      </div>
    </div>
  `;
}

function renderFailed(root, err) {
  const msg = err?.status === 400
    ? 'Ссылка просрочена или уже использована. Запроси новую ниже.'
    : (err?.message || 'Что-то пошло не так при подтверждении.');
  root.innerHTML = `
    <div class="auth-wrapper">
      <div class="auth-card text-center">
        <h1>Не получилось 🌀</h1>
        <p class="text-muted">${msg}</p>
        <div class="actions" style="display:flex; gap:10px; justify-content:center; flex-wrap:wrap;">
          <button id="resend" class="btn-ghost">Отправить новую ссылку</button>
          <a class="btn" href="/login" data-link>На вход</a>
        </div>
      </div>
    </div>
  `;
  root.querySelector('#resend')?.addEventListener('click', async () => {
    try {
      await api.auth.verifyRequest();
      toast('Ссылка отправлена — проверь почту', { type: 'success' });
    } catch (e) {
      toast('Не получилось отправить. Залогинься и повтори.', { type: 'error' });
    }
  });
}

function renderPendingInbox(root) {
  const user = store.user;
  const email = user?.email || 'твой email';
  root.innerHTML = `
    <div class="auth-wrapper">
      <div class="auth-card text-center">
        <h1>Проверь почту 📬</h1>
        <p class="text-muted">Письмо с подтверждением улетело на <strong>${escapeHtml(email)}</strong>. Перейди по ссылке из письма.</p>
        <div class="actions" style="display:flex; flex-direction: column; gap:10px;">
          <button id="resend" class="btn-ghost">Отправить письмо снова</button>
          <button id="change-email" class="btn-ghost">Адрес указан неверно — поменять</button>
          <a class="btn" href="/" data-link>На главную — пока без подтверждения</a>
        </div>
        <div class="change-email-box" id="change-email-box" style="display:none; margin-top: 18px;">
          <div class="field">
            <label for="new-email">Новый email</label>
            <input type="email" id="new-email" autocomplete="email" />
          </div>
          <button id="change-email-submit" class="btn">Поменять и отправить подтверждение</button>
        </div>
        <div class="form-error" id="form-error"></div>
      </div>
    </div>
  `;

  const errEl = root.querySelector('#form-error');
  const box = root.querySelector('#change-email-box');
  const input = root.querySelector('#new-email');

  root.querySelector('#resend')?.addEventListener('click', async () => {
    errEl.textContent = '';
    try {
      await api.auth.verifyRequest();
      toast('Отправили заново — проверь почту и «Спам»', { type: 'success' });
    } catch (e) {
      errEl.textContent = 'Нужно войти в аккаунт, чтобы отправить ссылку заново.';
    }
  });

  root.querySelector('#change-email')?.addEventListener('click', () => {
    box.style.display = box.style.display === 'none' ? 'block' : 'none';
    if (box.style.display === 'block') input.focus();
  });

  root.querySelector('#change-email-submit')?.addEventListener('click', async () => {
    errEl.textContent = '';
    const val = input.value.trim();
    if (!val || !val.includes('@')) {
      errEl.textContent = 'Введи корректный email';
      return;
    }
    try {
      const res = await api.auth.changeEmail(val);
      store.user = res.user;
      toast('Адрес обновлён — новое письмо в пути', { type: 'success' });
      renderPendingInbox(root);
    } catch (err) {
      if (err.status === 409) errEl.textContent = 'Этот email уже занят';
      else errEl.textContent = err.message || 'Не получилось поменять email';
    }
  });
}

function escapeHtml(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
